import request from '@/utils/request'
import host from '@/api/base/host'
import { AsyncRequest } from '@/utils/request'

const path = host.path('dev', { module: 'learningReport', dev: 'v1' })

export function getYearLearn(data) {
  return AsyncRequest({
    loading: true,
    request: () => request({ url: path('report/year/learn'), method: 'post', data })
  })
}
